import "chartjs-adapter-luxon";
import { DateTime } from "luxon";

const DateLabels = {
  id: "DateLabels",
  afterDatasetsDraw: (chart, args, pluginOptions) => {
    const {
      ctx,
      // eslint-disable-next-line no-unused-vars
      chartArea: { left, right, top, bottom, width, height },
    } = chart;
    ctx.save();
    if (chart) {
      if (chart.scales.x.ticks) {
        if (chart.scales.x.ticks.length > 2) {
          let dist =
            chart.scales.x._gridLineItems[1].tx1 -
            chart.scales.x._gridLineItems[0].tx1;

          // label dates
          for (let i = 0; i < chart.scales.x.ticks.length - 1; i++) {
            let tick = chart.scales.x.ticks[i];
            let x = chart.scales.x._gridLineItems[i].tx1;
            dateLabelText(tick.value, x + dist / 2);
          }
        }
      }
    }

    function dateLabelText(value, x) {
      ctx.save();
      let date = DateTime.fromMillis(value, {
        zone: "Canada/Mountain",
      })
        .toFormat("LLL dd")
        .toUpperCase();
      ctx.globalAlpha = 1.0;
      ctx.font = "12px Arial";
      ctx.fillStyle = "#666666";
      ctx.textAlign = "center";
      ctx.fillText(date, x, bottom + 15);
      ctx.restore();
    }
  },
};

export default DateLabels;
